// map from FlagAreaIdCode to FWLinkId
const defaultLinkId = '534338';
const PolicyLinkIdMap = {
  EV_0: defaultLinkId,
  EV_1: '2207237',
  EV_2: '2303306',
  EV_3: '534340',
  EV_4: '2207237',
  EV_5: '2206509',
  EV_6: '534512',
  EV_7: '534525',
  EV_8: '2299854',
  EV_9: defaultLinkId,
  EV_10: '2207237',
  EV_11: '2300216',
  EV_12: '2169175',
  EV_13: '2206949',
  EV_14: '534274',
  EV_15: '2299926',
  EV_16: '2299856',
  EV_17: '2207051',
  EV_18: '2207237',
  EV_19: '2302319',
  EV_20: '2207237',
  EV_21: '534282',
  EV_22: '534283',
  EV_23: '2206162',
  EV_24: '2300041',
  EV_25: '534481',
  EV_26: '2299855',
  EV_27: defaultLinkId,
  EV_28: '2205489',
  EV_29: '534482',
  EV_30: '534271',
  EV_31: '534273',
  EV_32: '534270',
  EV_33: '534393',
  EV_34: '534281',
  EV_35: '534530',
  EV_36: '534280',
  EV_37: '2300303',
  EV_38: '534284',
  EV_39: '2207057',
  EV_40: '2207237',
  EV_41: '2299856',
  EV_42: '2300224',
  EV_43: '534508',
  EV_44: '2206162',
  EV_45: '534515',
  EV_46: '2207237',
  EV_47: '2299860',
  EV_48: '2205489',
  EV_49: '534485',
  EV_50: '534576',
  EV_51: '534577',
  EV_53: '534339',
  EV_61: '2206243',
  EV_62: defaultLinkId,
  EV_63: '2206243',
  EV_64: defaultLinkId,
  EV_65: '534429',
  EV_66: '534342',
  EV_67: '534341',
  EV_68: '534340',
  EV_69: '534488',
  EV_70: '534343',
  EV_71: '534458',
  EV_72: '2206243',
  EV_73: '534560',
  EV_74: '534561',
  EV_77: '534526',
  EV_79: '534504',
  EV_81: '534526',
  EV_83: '597017',
  EV_84: defaultLinkId,
  EV_96: '2207053',
  EV_97: '534290',
  EV_98: '534291',
  EV_99: '2303306',
  EV_100: '2303306',
  EV_101: '534294',
  EV_102: '534295',
  EV_103: '534296',
  EV_104: '534297',
  EV_105: '534353',
  EV_106: '534354',
  EV_107: '534355',
  EV_109: '534433',
  EV_110: '534434',
  EV_111: '2299926',
  EV_112: '534436',
  EV_113: '534437',
  EV_114: '534438',
  EV_115: '534461',
  EV_116: '534462',
  EV_117: '534487',
  EV_118: '2300041',
  EV_119: '534399',
  EV_120: '534504',
  EV_121: '534505',
  EV_122: '534506',
  EV_124: '2206243',
  EV_125: '2206243',
  EV_126: '534562',
  EV_127: '534563',
  EV_128: '534564',
  EV_129: '2206243',
  EV_130: '534566',
  EV_131: '2206243',
  EV_132: '2304918',
  EV_133: '534358',
  EV_134: '534359',
  EV_135: '534356',
  EV_136: '534574',
  EV_137: '534307',
  EV_138: '534308',
  EV_139: '534309',
  EV_140: '534310',
  EV_141: '534311',
  EV_142: '534312',
  EV_143: '534313',
  EV_144: '534314',
  EV_145: '534315',
  EV_146: '534365',
  EV_147: '2299855',
  EV_148: '2299926',
  EV_149: '534445',
  EV_150: '2300213',
  EV_151: '2299853',
  EV_152: '2300302',
  EV_153: '534477',
  EV_154: '2300301',
  EV_155: '534516',
  EV_156: '2300041',
  EV_157: '534425',
  EV_158: '2303306',
  EV_159: '2299922',
  EV_160: '2207057',
  EV_161: '2299943',
  EV_162: '2300224',
  EV_163: '2300224',
  EV_164: '534370',
  EV_165: '534371',
  EV_166: '2303306',
  EV_167: '534318',
  EV_168: '534319',
  EV_169: '2299942',
  EV_170: '2207057',
  EV_171: '2207057',
  EV_172: '534569',
  EV_173: '534569',
  EV_174: '534570',
  EV_175: '534571',
  EV_176: '2299857',
  EV_177: '2206505',
  EV_178: '2299398',
  EV_179: '2300041',
  EV_180: '2300041',
  EV_181: defaultLinkId,
  EV_182: '2300041',
  EV_183: '2169175',
  EV_184: '2300041',
  EV_185: defaultLinkId,
  EV_186: defaultLinkId,
  EV_187: defaultLinkId,
  EV_188: '2300304',
  EV_189: defaultLinkId,
  EV_190: defaultLinkId,
  EV_191: '2300146',
  EV_192: defaultLinkId,
  EV_193: defaultLinkId,
  EV_194: defaultLinkId,
  EV_195: '2206243',
  EV_196: '534458',
  EV_197: defaultLinkId,
  EV_198: '534508',
  EV_199: '2207237',
  EV_200: defaultLinkId,
  EV_210: defaultLinkId,
  EV_211: defaultLinkId,
  EV_212: defaultLinkId,
  EV_213: '2299859',
  EV_214: defaultLinkId,
  EV_215: defaultLinkId,
  EV_216: '2299945',
  EV_217: defaultLinkId,
  EV_218: defaultLinkId,
  EV_219: defaultLinkId,
  EV_220: '2300041',
  EV_221: defaultLinkId,
  EV_222: defaultLinkId,
  EV_223: defaultLinkId,
  EV_224: defaultLinkId,
  EV_225: defaultLinkId,
  EV_226: defaultLinkId,
  EV_227: defaultLinkId,
  EV_228: defaultLinkId,
  EV_250: '2207062',
  EV_251: '2207237',
  EV_252: defaultLinkId,
  EV_254: '2206350',
  EV_255: '2206509',
  EV_256: '2207230',
  EV_257: '2206949',
  EV_258: '2299855',
  EV_260: '874905',
  EV_262: '2194432',
  EV_263: '2194432',
  EV_264: '2300216',
  EV_265: '2194432',
  EV_266: '2194432',
  EV_270: '2300042',
  EV_271: '2194528',
  EV_272: '2300042',
  EV_280: '2300041',
  EV_281: '2300041',
  EV_282: '2299925',
  EV_283: '2300041',
  EV_284: '2300041',
  EV_285: '2206243',
  EV_286: '2300030',
  EV_287: '2300030',
  EV_288: '2207230',
  EV_289: '2300146',
  EV_290: '2300146',
  EV_291: defaultLinkId,
  EV_292: '2300305',
  EV_293: '534502',
  EV_294: '2300041',
  EV_295: '2300041',
  EV_296: '2300041',
  EV_297: '2300041',
  EV_298: '2299926',
  EV_299: '2300216',
  EV_300: '2206243',
  EV_301: '2303306',
  EV_302: '2300224',
  EV_303: '2299856',
  EV_304: '2299854',
  EV_305: '2207057',
  EV_306: '2299926',
  EV_307: '2300041',
  EV_308: '2300216',
  EV_309: '2299926',
  EV_310: '2299942',
  EV_311: '2300144',
  EV_312: '2300041',
  EV_313: '2206243',
  EV_314: '2206243',
  EV_315: '2300303',
  EV_316: '2300215',
  EV_317: '2299854',
  EV_318: '2206243',
  EV_319: '2206243',
  EV_320: '2206243',
  EV_321: '2206243',
  EV_322: '2206243',
  EV_323: '2206243',
  EV_324: '2206243',
  EV_325: '2206243',
  EV_326: '2299856',
  EV_327: '2303306',
  EV_328: '2300224',
  EV_329: '2299926',
  EV_330: '2300215',
  EV_331: '2300041',
  EV_332: '2299854',
  EV_333: '2300303',
  EV_334: '2300303',
  EV_335: '2300030',
  EV_336: '2300041',
  EV_337: '2299926',
  EV_338: '2299926',
  EV_339: '2299926',
  EV_340: '2300041',
  EV_341: '2299923',
  EV_343: '2300215',
  EV_344: '2300215',
  EV_346: '2300048',
  EV_347: '2194519',
  EV_348: '2206437',
  EV_349: '2299861',
  EV_350: '2194521',
  EV_351: '2300041',
  EV_352: '2300041',
  EV_353: '2300224',
  EV_354: '2300224',
  EV_355: '2300041',
  EV_356: '2300041',
  EV_357: '2300041',
  EV_358: '2300041',
  EV_360: '2300215',
  EV_361: '2300041',
  EV_362: '2300041',
  EV_363: '2300041',
  EV_364: '2300041',
  EV_365: '2300030',
  EV_367: '2300041',
  EV_371: '2205489',
  EV_372: '2205489',
  EV_376: '534338',
  EV_381: '2194519',
  EV_399: '2304918',
  EV_501: '2304918',
  EV_502: '2304918',
  EV_503: '2299861',
  EV_504: '2304918',
  EV_505: '2304918',
  EV_506: '2304918',
  EV_507: '2304918',
  EV_508: '2304918',
  EV_509: '2304918',
  EV_510: '2300041',
  EV_511: '2299925',
  EV_512: '2207057',
  EV_513: '2299852',
  EV_514: '2300044',
  EV_515: '2206949',
  EV_516: '2207529',
  EV_517: '2299871',
  EV_518: '2300047',
  EV_519: '2206162',
  EV_520: '2300029',
  EV_521: '2207237',
  EV_522: '534338',
  EV_523: '2305009',
  EV_524: '2299944',
  EV_525: '2300224',
  EV_535: '2304918',
  EV_536: '2304918',
  EV_537: '2304918',
  EV_540: '2308432',
};

export const getPolicyLinkId = code => PolicyLinkIdMap[code] || defaultLinkId;
